export default __webpack_public_path__ + "61ef9126d71cc79ed0e06dd1c4d72dfc.png";